import {FormInstance} from 'antd/lib/form';
import React from 'react';
import {LabelAndKey} from './types/LabelAndKey';
import GenericSearchSelector from './GenericSearchSelector';

interface Props {
    dependencies?: string[]
    fieldValidator?(rule: any, value: any): Promise<void>
    criterion?: any
    form: FormInstance
}

const TrustSelector = ({dependencies, fieldValidator, criterion, form}: Props) => {

    const toLabel = (e: LabelAndKey) => {
        return e.label + ' (' + e.key + ')'
    }

    return <GenericSearchSelector
        fieldId="trusts"
        fieldLabel="Provider Trust"
        fieldURL="/trusts"
        dependencies={dependencies}
        fieldValidator={fieldValidator}
        fieldLabelFunction={toLabel}
        criterion={criterion}
        form={form}
    />
}

export default TrustSelector